<template>
    <div :class="isIframe ? 'p-0' : 'px-4 lg:px-24 py-4'">
        <div class="overflow-hidden rounded-d cursor-pointer relative" :class="preview ? 'h-[80vh] md:h-[80vh]' : 'h-[34vh] md:h-[50vh] bg-gray-100 '" id="three">
            <img
                v-if="!isIframe"
                :src="image3"
                @click="showImg(2)"
                alt="Materiaal tafelblad standingdesk"
                class="block sm:hidden rounded-lg size-16 object-cover absolute right-2 bottom-2 shadow-md"
            />
        </div>
        <div class="hidden mt-4 sm:grid grid-cols-2 md:grid-cols-2 xl:grid-cols-2 gap-4 sm:mt-6 sm:gap-6 lg:mt-8 lg:gap-8" v-if="!preview">
            <div class="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 cursor-pointer hover:shadow-xl transition duration-300">
                <img :src="image2" @click="showImg(0)"
                     alt="Materiaal tafelblad standingdesk"
                     class="h-full w-full object-cover object-center"/>
            </div>
            <div class="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 cursor-pointer hover:shadow-xl transition duration-300">
                <img :src="image3" @click="showImg(1)"
                     alt="Materiaal tafelblad standingdesk"
                     class="h-full w-full object-cover object-center"/>
            </div>
        </div>
    </div>
    <vue-easy-lightbox
        :visible="visible"
        :imgs="images"
        :index="index"
        :loop="true"
        :moveDisabled="true"
        :rotateDisabled="true"
        :zoomDisabled="true"
        @hide="visible = false"
    ></vue-easy-lightbox>
</template>

<script setup lang="ts">
import VueEasyLightbox from "vue-easy-lightbox";
import {nextTick, onMounted, Ref, ref, watch} from "vue";

const props = defineProps([
    'desk',
    'frameMaterial',
    'deskMaterial',
    'deskRadius',
    'image1',
    'image2',
    'image3',
    'preview',
    'isIframe'
]);

let image1 = ref();
let image2 = ref();
let image3 = ref();
let visible = ref(false);
let index = ref(0);
let images = ref<Ref<string>[]>([]);

const setImages = ()=>
{
    const image3radius = props.deskRadius === 0 && props.desk.slug === 'level-two' ? '-s' : '-r';

    image2.value = '/images/presets/'+(props.desk && !props.desk.pro ? 'standard-' : 'pro-') + props.frameMaterial.id + '-' + props.deskMaterial.id + (props.deskRadius ? '-r' : '-s') +'.jpg';
    image3.value = '/images/renders/sm/' +props.desk.slug+'/'+(props.desk && !props.desk.pro ? 'standard-' : 'pro-') + props.frameMaterial.id + '-' + props.deskMaterial.id + image3radius +'.jpg';
}


onMounted(() => {
    setImages();
    images.value = [ image2.value, image3.value];
});



const showImg = (i: number) => {
    index.value = i;
    visible.value = true;
}

watch(() => [props.deskMaterial, props.frameMaterial, props.deskRadius], () => {
    setImages();
    images.value = [image2.value, image3.value];
});
</script>
